import i18n from "i18next";
import { observable } from "mobx";
import moment from "moment";
import numeral from "numeral";
import { initReactI18next } from "react-i18next";
import "moment/locale/nl";
import "numeral/locales/nl-nl";

import GeneralStore from "../general/store";

moment.updateLocale("en", {
  calendar: {
    lastDay: "[Yesterday], D MMMM",
    sameDay: "[Today], D MMMM",
    nextDay: "[Tomorrow], D MMMM",
    lastWeek: "dddd, D MMMM",
    nextWeek: "dddd, D MMMM",
    sameElse: "ll",
  },
});

moment.updateLocale("nl", {
  calendar: {
    lastDay: "[Gisteren], D MMMM",
    sameDay: "[Vandaag], D MMMM",
    nextDay: "[Morgen], D MMMM",
    lastWeek: "dddd, D MMMM",
    nextWeek: "dddd, D MMMM",
    sameElse: "ll",
  },
});

class I18nStore extends GeneralStore {
  _locale = observable.box("nl-nl");

  constructor(store: any) {
    super(store);

    const resources = {
      nl: {
        translation: require("../../assets/locales/nl/translation.json"),
      },
    };

    i18n.on("languageChanged", (lng) => {
      this._locale.set(lng);
      numeral.locale(lng);
      moment.locale(lng);
    });

    i18n.use(initReactI18next).init({
      lng: this._locale.get(),
      // debug: !process.env.NODE_ENV || process.env.NODE_ENV === 'development',
      nsSeparator: false,
      keySeparator: false,
      interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
      },
      resources,
      react: {
        transKeepBasicHtmlNodesFor: ["br", "strong", "i", "span"],
      },
    });
  }

  get locale() {
    return this._locale.get();
  }

  get language() {
    return this.locale.split("-")[0];
  }
}

export default I18nStore;
